import { render, staticRenderFns } from "./BackHomeVideo.vue?vue&type=template&id=663223a6&scoped=true"
import script from "./BackHomeVideo.vue?vue&type=script&lang=js"
export * from "./BackHomeVideo.vue?vue&type=script&lang=js"
import style0 from "./BackHomeVideo.vue?vue&type=style&index=0&id=663223a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663223a6",
  null
  
)

export default component.exports